import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { SharedModalService } from './../shared-modal.service';
import { SharedHelperService } from '../shared-helper.service';
import { Router } from '@angular/router';
import { AuthServiceZ } from './../../authentification/auth-service.service';

@Component({
  selector: 'app-job-request-history',
  templateUrl: './job-request-history.component.html',
  styleUrls: ['./job-request-history.component.scss'],
})
export class JobRequestHistoryComponent implements OnChanges, OnInit {
  @Input() job;
  pickUpJobHistory = [];
  currentJobHistory = [];
  currentJobActionHistory = [];
  AllHistory: { date: string | Date; [key: string]: any }[] = [];
  callsHistory = [];
  ticketsHistory = [];
  supportHistory: { date: string | Date; [key: string]: any }[] = [];
  user;

  constructor(
    public sharedModalService: SharedModalService,
    public sharedHelperService: SharedHelperService,
    private authService: AuthServiceZ,
    public router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.user = this.authService?.credentials?.user?.userType;
    if (this.user === 'User') {
    }
  }

  ngOnChanges() {
    // changes.prop contains the old and the new value...
    this.currentJobHistory = [];
    this.callsHistory = [];
    this.supportHistory = [];
    this.AllHistory = [];

    if (this.job?._id) {
      Promise.all([
        this.getHistoryForAJob(this.job._id),
        this.getActionHistoryForAJob(this.job),
        this.getTicketsHistoryForAJob(this.job._id),
      ]).then(() => {
        this.prepareFullHistory();
      });
    }
  }

  formatDate(date: string) {
    return new Date(date).toISOString().split('T')[0];
  }
  prepareFullHistory() {
    this.AllHistory = [
      ...this.currentJobHistory.map((item: any) => ({
        ...item,
        date: item.date,
        status: item.editedByTicket ? 'T' : item.status,
      })),
      ...this.currentJobActionHistory.map((item: any) => ({
        ...item,
        date: item.date || item.createdAt,
        status: item.type == 'Appel' ? 'A1' : item.type,
      })),
    ];
    this.supportHistory = [
      ...this.ticketsHistory.map((item: any) => ({
        type: 'Ticket',
        status: item.status,
        date: item.createdAt,
        text: item.title,
      })),
      ...this.job?.comments?.map((item: any) => ({
        type: 'Commentaire',
        status: 0,
        date: item.date,
        text: item.text,
      })),
    ];

    this.AllHistory.sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );
    this.supportHistory.sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );

    const uniqueDates = new Set<string>();

    this.AllHistory.forEach((item) => {
      const date = this.formatDate(item.date.toString());
      if (uniqueDates.has(date)) {
        item.uniqueDate = null;
      } else {
        uniqueDates.add(date);
        item.uniqueDate = date;
      }
    });
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.AllHistory = [];
    this.supportHistory = [];
    this.currentJobHistory = [];
    this.callsHistory = [];
  }

  shareRecord(call) {
    this.sharedModalService.shareRecordWithClient(call._id).then((d) => {
      this.getActionHistoryForAJob(this.job);
      // this.sharedModalService
      //   .getJobRequestCallsHistory(this.job._id)
      //   .then((response) => {
      //     this.callsHistory = response;
      //   });
    });
  }

  getHistoryForAJob(jobId): Promise<any> {
    return new Promise((resolve, reject) => {
      const pickUpRequest = this.job?.pickUpJob?._id
        ? this.job.pickUpJob._id
        : this.job.pickUpJob;

      const queries = {
        jobRequests: [jobId],
        populate: [
          { path: 'driver jobRequest actionDoneBy centrale business' },
          { path: 'jobRequest', populate: { path: 'centrale' } },
        ],
      };

      pickUpRequest && queries.jobRequests.push(pickUpRequest);

      const params = this.sharedHelperService.convertObjectToParams(queries);

      this.sharedModalService
        .getJobRequestHistories(params)
        .then((d) => {
          this.currentJobHistory = d.body;
          resolve(d.body);
        })
        .catch(reject);
    });
  }

  getActionHistoryForAJob(jobId): Promise<any> {
    return new Promise((resolve, reject) => {
      const pickUpRequest = this?.job?.pickUpJob?._id
        ? this.job.pickUpJob._id
        : this.job.pickUpJob;

      const queries = {
        nid: jobId.nid,
        populate: 'driver jobRequest',
        jobRequests: [jobId._id],
      };

      pickUpRequest && queries['jobRequests'].push(pickUpRequest);

      this.sharedModalService
        .getJobRequestActionHistories(queries)
        .then((d) => {
          this.currentJobActionHistory = d;
          resolve(d);
        })
        .catch(reject);
    });
  }

  getTicketsHistoryForAJob(jobId): Promise<any> {
    return new Promise((resolve, reject) => {
      this.sharedModalService
        .getJobRequestTicketHistories(jobId)
        .then((d) => {
          this.ticketsHistory = d;
          resolve(d);
        })
        .catch(reject);
    });
  }

  changeVisibility(item, link, event) {
    if (event.target.checked) {
      return this.shareRecord(item);
    }

    this.sharedModalService
      .unshareRecordWithClient({ link, nid: item.nid })
      .then((d) => {
        this.getActionHistoryForAJob(this.job);
        // this.sharedModalService
        //   .getJobRequestCallsHistory(this.job._id)
        //   .then((response) => {
        //     this.callsHistory = response;
        //   });
      });
  }

  getSizeLabel(sizeNumber: number): string {
    const sizeLabels = {
      1: 'Petit',
      4: 'Grand',
      5: 'Très Grand'
    };
    return sizeLabels[sizeNumber] || 'Inconnu';
  }
}
